/*
  Perf 2026-09-09 — progressive loading for the collection grid.

  The grid used to render every product of the page in the initial HTML. On
  /collections/all that was 52 cards = 1,191 KB of markup, and each card carries an
  8 KB quick-add form, so the browser built the whole grid before it could paint.

  Products are NOT reduced: `products_per_page` now sets how much arrives up front,
  and the rest is appended as the shopper approaches the end of the list.

  The server-rendered <nav class="pagination"> stays in the DOM untouched. Crawlers and
  no-JS shoppers keep working links; this script only hides it once it has taken over,
  and puts it back if a fetch fails. Nothing here runs unless the section setting is on.
*/
(function () {
  var LOAD_MARGIN = '600px'; // start fetching this far before the sentinel is visible

  function initAll() {
    var roots = document.querySelectorAll('[data-collection-infinite][data-enabled="true"]');
    for (var i = 0; i < roots.length; i++) setup(roots[i]);
  }

  function setup(root) {
    if (root.dataset.bound === '1') return;
    root.dataset.bound = '1';

    var grid = document.getElementById('product-grid');
    if (!grid || !root.dataset.nextUrl) return;

    var nav = root.querySelector('.pagination-wrapper');
    var status = root.querySelector('[data-infinite-status]');
    var loading = false;

    // Progressive enhancement: only hide the real pagination once we know we can
    // replace it, so a shopper never ends up with no way forward.
    if (nav) nav.hidden = true;

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'button button--secondary collection-infinite__more';
    button.textContent = 'Load more products';
    button.addEventListener('click', function () { load(); });
    root.appendChild(button);

    function say(msg) { if (status) status.textContent = msg; }

    function finish() {
      button.remove();
      if (observer) observer.disconnect();
      say('All products loaded.');
    }

    // If anything goes wrong, restore the server-rendered pagination and step aside.
    function bail() {
      button.remove();
      if (observer) observer.disconnect();
      if (nav) nav.hidden = false;
      say('');
    }

    function load() {
      if (loading || !root.dataset.nextUrl) return;
      loading = true;
      button.disabled = true;
      button.textContent = 'Loading…';
      say('Loading more products…');

      fetch(root.dataset.nextUrl, { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nextGrid = doc.getElementById('product-grid');
          if (!nextGrid) throw new Error('no grid in response');

          var added = 0;
          // Move nodes rather than re-parsing innerHTML, so custom elements inside a
          // card (quick-add, rating) upgrade exactly once.
          while (nextGrid.firstElementChild) {
            grid.appendChild(document.adoptNode(nextGrid.firstElementChild));
            added++;
          }

          var nextRoot = doc.querySelector('[data-collection-infinite]');
          root.dataset.nextUrl = (nextRoot && nextRoot.dataset.nextUrl) || '';

          loading = false;
          button.disabled = false;
          button.textContent = 'Load more products';
          say(added + ' more products loaded.');

          if (!root.dataset.nextUrl) finish();
        })
        .catch(function () {
          loading = false;
          bail();
        });
    }

    var observer = null;
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) if (entries[i].isIntersecting) load();
      }, { rootMargin: LOAD_MARGIN });
      observer.observe(root);
    }
    // Without IntersectionObserver the button alone carries it — still no dead end.
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  /*
    facets.js replaces #ProductGridContainer.innerHTML when filters or sorting change
    and dispatches no event, so re-init on that container's childList. Scoped to one
    element and not subtree, so it costs nothing on a normal page.
  */
  var container = document.getElementById('ProductGridContainer');
  if (container && 'MutationObserver' in window) {
    new MutationObserver(function () { initAll(); }).observe(container, { childList: true });
  }
})();
